import { selx } from "clsx";
import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { InputEl } from "common/components/input";
import { ModalEl } from "common/components/modal";
import { SpinnerEl } from "common/components/spinner";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
import { BannerEl } from "common/components/banner";
import { BannerTheme, BannerType } from "common/components/banner/types";
import { CohortsBuilderEl } from "common/query-builder/cohorts-query-builder/panel";
import { CreateEntityModalEl } from "common/widgets/create-entity-modal";
import { SkeletonListEl } from "common/components/skeleton-list";
import { SvgIconEl } from "common/components/svg-icon";
import { ModalTrigger } from "../in-product-upsell-modal/util";
import { promptInProductUpsellModal } from "../in-product-upsell-modal/prompt";
import styles from "./index.module.styl";
export function template() {
  const { cohort, errors, loadingCohortCount, name, showCreateEntityModal } = this.state;
  const SaveCohortButton = ({ text, theme }) => /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: selx(styles.inlineCohortsButton),
      attrs: {
        theme,
        elref: `saveButton`
      },
      on: {
        click: () => {
          if (this.helpers.shouldRenderUpsellModal()) {
            promptInProductUpsellModal(ModalTrigger.COHORT);
          } else {
            this.helpers.saveStagedCohortOnInlineModal();
          }
        }
      }
    },
    this.helpers.shouldRenderUpsellModal() && /* @__PURE__ */ jsx(SvgIconEl, { sel: selx(styles.buttonIcon), attrs: { icon: `brand-upgrade` } }),
    text
  );
  const ApplyCohortButton = ({ text }) => /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: selx(styles.inlineCohortsButton),
      attrs: { elref: `inlineCohortsButton`, theme: ButtonTheme.Primary },
      on: { click: this.helpers.commitCohort }
    },
    text
  );
  return /* @__PURE__ */ jsx("div", { sel: selx(styles.inlineCohortsModal) }, this.helpers.isOpen() && showCreateEntityModal ? /* @__PURE__ */ jsx(
    CreateEntityModalEl,
    {
      attrs: this.helpers.buildCreateEntityModalAttrs(),
      on: {
        cancel: this.helpers.closeEntityModal,
        save: this.helpers.saveStagedCohortOnCreateModal,
        saveAndShare: this.helpers.saveStagedCohortOnCreateModal
      },
      props: {
        existingEntityNames: this.helpers.getCohortNames()
      }
    }
  ) : /* @__PURE__ */ jsx(
    ModalEl,
    {
      sel: selx(styles.inlineCohortsModal),
      attrs: this.helpers.getModalAttributes(),
      on: {
        change: this.helpers.handleModalStateChange
      },
      hook: {
        postpatch: () => this.state.showQueryBuilderSkeleton && this.update({ showQueryBuilderSkeleton: false })
      }
    },
    /* @__PURE__ */ jsx("section", { sel: selx(styles.inlineCohortsModalScrollWrapper) }, /* @__PURE__ */ jsx("section", { sel: selx(styles.inlineCohortsModalHeader) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.mpFontSizeXxl, styles.mpFontWeightBold), attrs: { elref: `modalTitle` } }, this.helpers.getTitle()), this.state.cohort.id && /* @__PURE__ */ jsx("div", { sel: selx(styles.mpFontSizeSmall) }, this.t(`users.cohorts.cohort-id`), " ", this.state.cohort.id)), /* @__PURE__ */ jsx("section", { sel: selx(styles.inlineCohortsWorkspace) }, /* @__PURE__ */ jsx("section", { sel: selx(styles.inlineCohortsBuilder) }, this.state.showQueryBuilderSkeleton && /* @__PURE__ */ jsx(SkeletonListEl, null), this.helpers.isOpen() && !this.state.showQueryBuilderSkeleton ? /* @__PURE__ */ jsx(null, null, !this.helpers.isNewSavedCohort() && !this.attr(`can-edit`) ? /* @__PURE__ */ jsx("div", { sel: selx(styles.inlineCohortsEditBanner) }, /* @__PURE__ */ jsx(
      BannerEl,
      {
        attrs: {
          theme: BannerTheme.Info,
          type: BannerType.Embedded,
          "body-text": this.helpers.getBannerText(),
          elref: `permissionBanner`
        },
        style: {
          "text-transform": `initial`
        }
      }
    )) : /* @__PURE__ */ jsx("section", { sel: selx(styles.inlineCohortsNameInput) }, /* @__PURE__ */ jsx(
      InputEl,
      {
        attrs: {
          placeholder: this.t(`users.cohorts.name-placeholder`),
          maxlength: 190,
          "validation-status": errors.size > 0 ? `invalid` : ``,
          "error-message": this.helpers.getCohortNameError(),
          elref: `inlineCohortsNameInputBox`
        },
        props: {
          value: name
        },
        on: {
          input: this.helpers.handleNameInputChange
        }
      }
    )), /* @__PURE__ */ jsx("section", { sel: selx(styles.inlineCohortsBuilderQbWrapper) }, this.helpers.isEditableCohort() && this.state.showQueryBuilderSkeleton && /* @__PURE__ */ jsx(SkeletonListEl, null), this.helpers.isEditableCohort() && !this.state.showQueryBuilderSkeleton && /* @__PURE__ */ jsx(
      CohortsBuilderEl,
      {
        elref: `cohortBuilder`,
        sel: selx(styles.cohortsBuilder),
        trackName: this.attr(`track-name`),
        cohort: cohort.serialize(),
        projectId: this.attr(`project-id`),
        workspaceId: this.attr(`workspace-id`),
        projectHasCohorts: this.attr(`project-has-cohorts`),
        supportB2bCohorts: this.attr(`support-b2b-cohorts`),
        dataGroupId: this.attr(`data-group-id`),
        userId: this.attr(`user-id`),
        nonCollapsible: true,
        onCohortUpdate: this.helpers.handleCohortUpdated,
        onTrack: this.helpers.trackCohortsBuilderEvent
      }
    ), !this.helpers.isEditableCohort() && /* @__PURE__ */ jsx("div", { sel: selx(styles.noCohortDefinition) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.cohortNotEditableText), attrs: { elref: `cohortNotEditableText` } }, this.helpers.getDisabledEditingReason()), /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(
      ButtonEl,
      {
        attrs: {
          icon: `share`,
          elref: `viewUsersButton`
        },
        on: { click: this.helpers.openCohortViewUser }
      },
      this.t(`users.cohorts.view-users`)
    ))))) : null, /* @__PURE__ */ jsx("div", { sel: selx(styles.inlineCohortsBuilderFooter) }, /* @__PURE__ */ jsx("div", { sel: selx(styles.leftControls) }, this.attr(`show-cohort-count`) ? /* @__PURE__ */ jsx("div", { sel: selx(styles.cohortCount) }, loadingCohortCount ? /* @__PURE__ */ jsx(SpinnerEl, null) : /* @__PURE__ */ jsx("div", { attrs: { elref: `countNumber` } }, this.helpers.displayCohortCount())) : null, this.attr(`can-save`) ? this.helpers.isSavingRestricted() && !this.helpers.shouldRenderUpsellModal() ? /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(TooltipEl, { attrs: { placement: Placement.Right } }, this.t(`users.cohorts.upgrade-description`)), /* @__PURE__ */ jsx(
      ButtonEl,
      {
        attrs: {
          icon: `share`
        },
        on: { click: this.helpers.openPricingUpsell }
      },
      this.t(`users.cohorts.upgrade-cta`)
    )) : null : null), /* @__PURE__ */ jsx("div", { sel: selx(styles.rightControls) }, this.attr(`can-apply-unsaved-cohort`) && this.attr(`can-save`) ? /* @__PURE__ */ jsx(
      SaveCohortButton,
      {
        text: this.helpers.isNewUnsavedCohort() ? this.t(`users.cohorts.create-and-save`) : this.t(`users.cohorts.edit-and-save`),
        theme: ButtonTheme.Secondary
      }
    ) : null, this.attr(`can-apply-unsaved-cohort`) ? /* @__PURE__ */ jsx(
      ApplyCohortButton,
      {
        text: this.helpers.isNewUnsavedCohort() ? this.t(`users.cohorts.create`) : this.t(`users.cohorts.edit`)
      }
    ) : /* @__PURE__ */ jsx(null, null, !this.helpers.isNewSavedCohort() && !this.attr(`can-edit`) ? this.helpers.isEditableCohort() ? /* @__PURE__ */ jsx(
      ButtonEl,
      {
        attrs: {
          theme: ButtonTheme.Secondary,
          elref: `saveButton`,
          "not-focusable": true
        },
        on: {
          click: () => this.helpers.saveStagedCohortOnInlineModal(true)
        }
      },
      this.t(`users.cohorts.save-as-new`)
    ) : null : /* @__PURE__ */ jsx(
      SaveCohortButton,
      {
        text: this.helpers.isNewCohort() ? this.t(`users.cohorts.create`) : this.t(`common.save`),
        theme: ButtonTheme.Primary
      }
    )))))))
  ));
}
